import { LOGIN_DATA } from "./actionTypes";

export const loginData = e => ({
  type: LOGIN_DATA,
  payload: e,
});
